import { calculateViewportUnits, calculateHeaderSize } from 'Functions/window';

let resizeTimer = false

calculateViewportUnits()
calculateHeaderSize()

window.customLastInnerWidth = window.innerWidth
window.addEventListener('resize', event => {
    clearTimeout(resizeTimer);

    resizeTimer = setTimeout(function () {
        calculateViewportUnits()
        calculateHeaderSize()

        if (window.customLastInnerWidth !== window.innerWidth) {
            window.rEvent.dispatch('Window.resized')
        }

        window.customLastInnerWidth = window.innerWidth
    }, 250)
})
